import { render, staticRenderFns } from "./zxzx.vue?vue&type=template&id=6c7c7bea&scoped=true"
import script from "./zxzx.vue?vue&type=script&lang=js"
export * from "./zxzx.vue?vue&type=script&lang=js"
import style0 from "./zxzx.vue?vue&type=style&index=0&id=6c7c7bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7c7bea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonTitleRow: require('/builds/wj/fe/wenjuan-homesite/components/common/title-row.vue').default,CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default,CommonSvg: require('/builds/wj/fe/wenjuan-homesite/components/common/svg.vue').default})
